"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var level_1 = require("./level");
var helper_1 = require("./helper");
var backend_logging_1 = require("./backend-logging");
var logger_1 = require("./logger");
if (helper_1.Helpers.isNode) {
  //#region @backend
  var chalk = require('chalk');
  var path = require('path');
  //#endregion
}
var Display = /** @class */function () {
  function Display() {}
  Display.msg = function (message, params, moduleName, moduleColor, level, moduleWidth) {
    var color = 'gray';
    if (level === level_1.Level.INFO) color = 'deepskyblue';
    if (level === level_1.Level.ERROR) color = 'red';
    if (level === level_1.Level.WARN) color = 'orange';
    if (moduleWidth) {
      var diff = moduleWidth - moduleName.length;
      if (diff > 0) {
        for (var i = 0; i < diff; i++) {
          moduleName += ' ';
        }
      }
    }
    if (logger_1.Logger.isProductionMode) return this;
    if (helper_1.Helpers.isBrowser) {
      var isEdgeOrIe8orAbove = document['documentMode'] || /Edge/.test(navigator.userAgent);
      if (isEdgeOrIe8orAbove) {
        if (typeof message === 'string') {
          var a1 = '[[ ' + moduleName + ' ]] ' + message + ' ';
          params.unshift(a1);
        } else {
          var a1 = '[[ ' + moduleName + ']] ';
          params.push(message);
          params.unshift(a1);
        }
        if (level === level_1.Level.INFO) {
          console.info.apply(console, params);
        } else if (level === level_1.Level.ERROR) {
          console.error.apply(console, params);
        } else if (level === level_1.Level.WARN) {
          console.warn.apply(console, params);
        } else {
          console.log.apply(console, params);
        }
      } else {
        if (typeof message === 'string') {
          var a1 = '%c ' + moduleName + '  %c ' + message + ' ';
          var a2 = 'background: ' + moduleColor + ';color:white; border: 1px solid ' + moduleColor + '; ';
          var a3 = 'border: 1px solid ' + color + '; ';
          params.unshift(a3);
          params.unshift(a2);
          params.unshift(a1);
        } else {
          var a1 = '%c ' + moduleName + ' ';
          var a2 = 'background: ' + moduleColor + ';color:white; border: 1px solid ' + color + '; ';
          params.push(message);
          params.unshift(a2);
          params.unshift(a1);
        }
        console.log.apply(console, params);
      }
    }
    if (helper_1.Helpers.isNode) {
      //#region @backend
      var a1 = chalk.bgHex(moduleColor)(chalk.black(moduleName));
      var p = params;
      if (typeof message === 'string') {
        a1 = a1 + chalk.keyword(color)(' [') + chalk.dim(message) + chalk.keyword(color)('] ');
      } else {
        p = [message].concat(params);
      }
      backend_logging_1.consoleLog(a1, level);
      backend_logging_1.displayParams(p, level);
      //#endregion
    }
  };
  return Display;
}();
exports.Display = Display;